import styled from "@emotion/styled";
export const EmptyStateRoot = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
`;
